import { ClientScheduleCalendar } from '@apps/web/components/clients/client_schedule_calendar';
import { Spinner } from '@apps/web/components/ui/spinner';
import { type OrgClientRead } from '@libraries/typescript/api_client';

type ClientOverviewProps = {
    readonly organizationId: string;
    readonly client: OrgClientRead;
    readonly timezone: string | null;
    readonly onShiftClick: (shiftId: string) => void;
};

/**
 * The client popup's "Calendar" section: this month's schedule and nothing
 * else. The care plan, profile note, and Phoebe's notes each have their own
 * section, so pairing them with the calendar here only competed with it for
 * height — a client with several visits a day already makes this taller than
 * the popup.
 */
export function ClientOverview({
    organizationId,
    client,
    timezone,
    onShiftClick,
}: ClientOverviewProps) {
    if (!timezone) {
        return (
            <div className="flex h-40 items-center justify-center">
                <Spinner className="size-5" />
            </div>
        );
    }
    return (
        <div className="h-full min-w-0">
            <ClientScheduleCalendar
                organizationId={organizationId}
                clientId={client.id}
                timezone={timezone}
                onShiftClick={onShiftClick}
            />
        </div>
    );
}
